import firebaseApp from "../firebase/credenciales";
import { getFirestore, doc, getDoc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getOnlyUserRUC(baseDatos, ruc) {
  const docRef = doc(db, baseDatos, ruc); // Accede directamente al documento
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data(); // Retorna los datos del documento si existe
  } else {
    return null; // Retorna null si el documento no existe
  }
}
